/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */

/* eslint-enable no-console */



document.addEventListener("DOMContentLoaded", function (event) {

	//wait until images, links, fonts, stylesheets, and js is loaded
	window.addEventListener("load", function (e) {

		let mm = gsap.matchMedia();

		mm.add("(min-width: 500px)", () => {

		// apply parallax effect to any element with a data-speed attribute
		gsap.to("[data-speed]", {
			y: (i, el) => (1 - parseFloat(el.getAttribute("data-speed"))) * ScrollTrigger.maxScroll(window),
			ease: "none",
			scrollTrigger: {
				start: 50,
				end: "max",
				invalidateOnRefresh: true,
				scrub: 0
			}
		});

	});





		//fade in on scroll:
		const boxes = gsap.utils.toArray('.wp-block-so-parallax-images-so-parallax-images img');

		boxes.forEach((box, i) => {

			const anim = gsap.fromTo(box, { autoAlpha: 0 }, { duration: 1, autoAlpha: 1});

			ScrollTrigger.create({
				trigger: box,
				animation: anim,
				toggleActions: 'play none none none',
				once: true,
			});
		});

	}, false);

});